import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const EMAILJS_SERVICE_ID  = 'service_obda34u';
const EMAILJS_TEMPLATE_ID = 'template_ee8aztu';
const EMAILJS_PUBLIC_KEY  = 'ur_JzUjQwOUEc2m-v';

export default function Prayer() {
  const [submitted, setSubmitted] = useState(false);
  const [anonymous, setAnonymous] = useState(false);
  const [form, setForm] = useState({
    name: '', email: '', request: '', private: false,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.request.trim()) return;
    setLoading(true);
    setError('');
    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          to_email:   'alvaro@bethesdacommunitychurch.com',
          from_name:  anonymous ? 'Anónimo' : (form.name  || 'Anónimo'),
          from_email: anonymous ? 'Anónimo' : (form.email || 'No proporcionado'),
          is_private: form.private ? 'Sí' : 'No',
          message:    form.request,
        },
        EMAILJS_PUBLIC_KEY
      );
      setSubmitted(true);
    } catch (err) {
      console.error('EmailJS error:', err);
      setError(`Error: ${err?.text || err?.message || JSON.stringify(err)}`);
    }
    setLoading(false);
  };

  if (submitted) {
    return (
      <>
        <h2 className="page-title">💌 Petición de Oración</h2>
        <div className="card" style={{ textAlign: 'center', padding: '40px 24px' }}>
          <div style={{ fontSize: '3.5rem', marginBottom: 16 }}>🙏</div>
          <h3 style={{ fontSize: '1.4rem', color: 'var(--navy)', marginBottom: 12 }}>
            ¡Tu petición fue recibida!
          </h3>
          <p style={{ color: '#555', marginBottom: 8 }}>
            Nuestro equipo de oración creerá junto a ti.
          </p>
          {!anonymous && form.name ? (
            <p style={{ color: '#555' }}>Estaremos orando por ti, <strong>{form.name}</strong>. 🙏</p>
          ) : (
            <p style={{ color: '#555' }}>Tu petición es confidencial. 🙏</p>
          )}
          <p className="verse" style={{ marginTop: 20 }}>
            "Por nada estéis afanosos, sino sean conocidas vuestras peticiones delante de Dios en toda oración y ruego, con acción de gracias."
            <br /><strong>— Filipenses 4:6</strong>
          </p>
          <button
            className="btn gold"
            style={{ marginTop: 24 }}
            onClick={() => {
              setSubmitted(false);
              setAnonymous(false);
              setForm({ name: '', email: '', request: '', private: false });
            }}
          >
            Enviar Otra Petición
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <h2 className="page-title">💌 Petición de Oración</h2>

      <div className="card">
        <p>Estamos aquí para orar contigo. Comparte tu petición y nuestro equipo de oración creerá junto a ti.</p>

        <form className="prayer-form" onSubmit={handleSubmit}>

          {/* Anonymous toggle */}
          <div style={{
            background: anonymous ? '#f0f4ff' : '#f9fafc',
            border: `2px solid ${anonymous ? 'var(--navy)' : '#e0e4ef'}`,
            borderRadius: 10,
            padding: '12px 16px',
            marginTop: 16,
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            cursor: 'pointer',
          }} onClick={() => setAnonymous(!anonymous)}>
            <input
              type="checkbox"
              checked={anonymous}
              onChange={() => setAnonymous(!anonymous)}
              style={{ width: 18, height: 18, cursor: 'pointer' }}
            />
            <div>
              <p style={{ fontWeight: 700, color: 'var(--navy)', fontSize: '0.95rem' }}>
                🕵️ Enviar como Anónimo
              </p>
              <p style={{ fontSize: '0.8rem', color: '#666', marginTop: 2 }}>
                Tu nombre y correo no serán compartidos
              </p>
            </div>
          </div>

          {/* Name & Email — hidden if anonymous */}
          {!anonymous && (
            <>
              <label htmlFor="pr-name">Nombre (opcional)</label>
              <input
                id="pr-name"
                type="text"
                placeholder="Tu nombre"
                value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })}
              />

              <label htmlFor="pr-email">Correo Electrónico (opcional)</label>
              <input
                id="pr-email"
                type="email"
                placeholder="tu@correo.com"
                value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })}
              />
            </>
          )}

          <label htmlFor="pr-request">Tu Petición de Oración *</label>
          <textarea
            id="pr-request"
            required
            placeholder="Comparte tu petición aquí..."
            value={form.request}
            onChange={e => setForm({ ...form, request: e.target.value })}
          />

          {error &&<p style={{ color: '#e53e3e', fontSize: '0.88rem', marginTop: 10 }}>{error}</p>}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Enviando...' : '🙏 Enviar Petición'}
          </button>
        </form>
      </div>

      <div className="card">
        <p className="verse">
          "Por nada estéis afanosos, sino sean conocidas vuestras peticiones delante de Dios en toda oración y ruego, con acción de gracias."
          <br /><strong>— Filipenses 4:6</strong>
        </p>
      </div>
    </>
  );
}
